<script lang="ts">
import { defineComponent } from 'vue';
import { PlusIcon } from 'vue-feather-icons';
export default defineComponent({
    name: 'NewChatButton',
    components: {
        PlusIcon
    },
    setup() {
        return {
        }
    }
})
</script>

<template>
    <div class="p-3 bg-transparent flex gap-2 rounded-b-2xl">
        <button class="w-full bg-[#6E53F2] text-white rounded-lg px-[16px] py-[4px] flex items-center justify-center gap-1 hover:bg-[#5936E5] transition-all duration-300">
            <PlusIcon width="16" height="16" class="text-white font-bold" />
            <span class="text-sm/[18px] font-bold border-1 border-[#00000016] rounded-full px-2 py-1">Nova conversa</span>
        </button>
    </div>
</template>



